import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { faArrowsRotate as arrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faAt as at } from '@fortawesome/pro-solid-svg-icons/faAt';
import { faBadgePercent as badgePercent } from '@fortawesome/pro-solid-svg-icons/faBadgePercent';
import { faBars as bars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faBarsProgress as barsProgress } from '@fortawesome/pro-solid-svg-icons/faBarsProgress';
import { faBookUser as bookUser } from '@fortawesome/pro-solid-svg-icons/faBookUser';
import { faBoxOpen as boxOpen } from '@fortawesome/pro-solid-svg-icons/faBoxOpen';
import { faBrowser as browser } from '@fortawesome/pro-solid-svg-icons/faBrowser';
import { faCircleCheck as circleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircleExclamation as circleExclamation } from '@fortawesome/pro-solid-svg-icons/faCircleExclamation';
import { faClock as clock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { faCloudUploadAlt as cloudUploadAlt } from '@fortawesome/pro-solid-svg-icons/faCloudUploadAlt';
import { faCode as code } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faCoins as coins } from '@fortawesome/pro-solid-svg-icons/faCoins';
import { faDatabase as database } from '@fortawesome/pro-solid-svg-icons/faDatabase';
import { faDollarSign as dollarSign } from '@fortawesome/pro-solid-svg-icons/faDollarSign';
import { faEnvelope as envelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEuroSign as euroSign } from '@fortawesome/pro-solid-svg-icons/faEuroSign';
import { faEye as eye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faEyeSlash as eyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faFiles as files } from '@fortawesome/pro-solid-svg-icons/faFiles';
import { faFireFlameCurved as fireFlameCurved } from '@fortawesome/pro-solid-svg-icons/faFireFlameCurved';
import { faGlobe as globe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faInfoCircle as infoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLink as link } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faLock as lock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { faMagnifyingGlass as magnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faMessageLines as messageLines } from '@fortawesome/pro-solid-svg-icons/faMessageLines';
import { faMessages as messages } from '@fortawesome/pro-solid-svg-icons/faMessages';
import { faMoneyBill as moneyBill } from '@fortawesome/pro-solid-svg-icons/faMoneyBill';
import { faPeopleArrows as peopleArrows } from '@fortawesome/pro-solid-svg-icons/faPeopleArrows';
import { faPeopleGroup as peopleGroup } from '@fortawesome/pro-solid-svg-icons/faPeopleGroup';
import { faPersonRunning as personRunning } from '@fortawesome/pro-solid-svg-icons/faPersonRunning';
import { faPoundSign as poundSign } from '@fortawesome/pro-solid-svg-icons/faPoundSign';
import { faReceipt as receipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faRetweet as retweet } from '@fortawesome/pro-solid-svg-icons/faRetweet';
import { faRightLeft as rightLeft } from '@fortawesome/pro-solid-svg-icons/faRightLeft';
import { faRightToBracket as rightToBracket } from '@fortawesome/pro-solid-svg-icons/faRightToBracket';
import { faRotate as rotate } from '@fortawesome/pro-solid-svg-icons/faRotate';
import { faShieldCheck as shieldCheck } from '@fortawesome/pro-solid-svg-icons/faShieldCheck';
import { faSpinner as spinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { faSquareQuestion as squareQuestion } from '@fortawesome/pro-solid-svg-icons/faSquareQuestion';
import { faTag as tag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faToggleOff as toggleOff } from '@fortawesome/pro-solid-svg-icons/faToggleOff';
import { faToggleOn as toggleOn } from '@fortawesome/pro-solid-svg-icons/faToggleOn';
import { faTrash as trash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faTriangleExclamation as triangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faUsers as users } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faXmark as xmark } from '@fortawesome/pro-solid-svg-icons/faXmark';

const icons: Record<string, IconDefinition> = {
  arrowsRotate,
  at,
  badgePercent,
  bars,
  barsProgress,
  bookUser,
  boxOpen,
  browser,
  circleCheck,
  circleExclamation,
  clock,
  cloudUploadAlt,
  code,
  coins,
  database,
  dollarSign,
  envelope,
  euroSign,
  eye,
  eyeSlash,
  files,
  fireFlameCurved,
  globe,
  infoCircle,
  link,
  lock,
  magnifyingGlass,
  messageLines,
  messages,
  moneyBill,
  peopleArrows,
  peopleGroup,
  personRunning,
  poundSign,
  receipt,
  retweet,
  rightLeft,
  rightToBracket,
  rotate,
  shieldCheck,
  spinner,
  squareQuestion,
  tag,
  toggleOff,
  toggleOn,
  trash,
  triangleExclamation,
  users,
  xmark,
};

export default icons;
